import React from "react";

export default function PayForOrderIcon({ orderId }) {
    if (!orderId) return null;

    const handlePay = async () => {
        try {
            const editUrl = `https://curbstand.com/wp-admin/post.php?post=${orderId}&action=edit&open_payment=1`;
            window.open(editUrl, "_blank");
        } catch (error) {
            console.error("Failed to open pay link:", error);
        }
    };

    return (
        <i
            className="bx bx-credit-card"
            title="Pay for Order"
            style={{
                cursor: "pointer",
                fontSize: 15,
                color: "#28a745",
                marginLeft: 10,
            }}
            onClick={handlePay}
        ></i>
    );
}